<template>
  <div class="detailsTop">
    <!-- 个人代理人 -->
    <div v-if="data.type == 1">
      <div
        class="item"
        v-if="data.status != -3 && data.is_no_pay_order && countDown > 0"
      >
        <div class="tipContent">
          <p>代理人申请订单将在{{ countDown | dataFormatting }}关闭</p>
          <span @click="toPay()">去支付</span>
        </div>
      </div>
      <div
        class="item"
        v-if="
          data.status != -3 && data.is_renewal_no_pay_order && countDown > 0
        "
      >
        <div class="tipContent">
          <p>续费申请订单将在{{ countDown | dataFormatting }}关闭</p>
          <span @click="toPay()">去支付</span>
        </div>
      </div>
      <div
        class="item"
        v-if="
          data.status != -3 &&
          (data.is_renewal_no_pay_order || data.is_no_pay_order) &&
          countDown == 0
        "
      >
        <div class="tipContent">
          <p>代理人申请订单超时未支付，订单已关闭</p>
          <span @click="afreshSign()">重新申请</span>
        </div>
      </div>
      <div
        class="item"
        v-if="
          data.status != -3 &&
          data.city_agent_contract &&
          data.city_agent_contract.status == -5 &&
          data.order_status != -10 &&
          data.order_status != -20
        "
      >
        <div class="tipContent">
          <p>合同已撤回</p>
          <span @click="afreshSign()">重新申请</span>
        </div>
      </div>
      <div
        class="item"
        v-if="data.payment_type == 1 && data.status >= 10 && data.status < 2000"
      >
        <div class="tipContent">
          <p>审核中</p>
        </div>
      </div>
      <div class="item" v-if="data.payment_type == 1 && data.status == -4">
        <div class="tipContent">
          <p ref="detailDom" :class="{ unfold: isUnfold }">
            被驳回：{{ data.reason }}
          </p>
          <span @click="afreshSign()">重新申请</span>
        </div>
        <div class="tipMore" v-if="showDetailBtn">
          <span v-if="!isUnfold" @click="isUnfold = true"
            >展开<img src="./../../../assets/decoration/moreBottom.png" alt=""
          /></span>
          <span v-if="isUnfold" @click="isUnfold = false"
            >关闭<img src="./../../../assets/decoration/moreTop.png" alt=""
          /></span>
        </div>
      </div>
      <div
        class="item"
        v-if="
          data.payment_type == 2 &&
          data.status == -4 &&
          (data.order_status == -10 || data.order_status == -20)
        "
      >
        <div class="tipContent">
          <p>当前订单已关闭</p>
          <span @click="afreshSign()">重新申请</span>
        </div>
      </div>
      <div class="item" v-if="data.is_invalid">
        <div class="tipContent">
          <p>合同已到期</p>
          <span @click="renewalSign()">续签</span>
        </div>
      </div>
      <div class="item" v-if="data.is_expiring && data.status == 2000">
        <div class="tipContent">
          <p>合同即将到期</p>
          <span @click="renewalSign()">续签</span>
        </div>
      </div>
      <div class="item" v-if="data.status == -3">
        <div class="tipContent">
          <p ref="detailDom" :class="{ unfold: isUnfold }">
            您已被拉黑，请尽快联系工作人员处理。 拉黑原因：{{ data.reason }}
          </p>
        </div>
        <div class="tipMore" v-if="showDetailBtn">
          <span v-if="!isUnfold" @click="isUnfold = true"
            >展开<img src="./../../../assets/decoration/moreBottom.png" alt=""
          /></span>
          <span v-if="isUnfold" @click="isUnfold = false"
            >关闭<img src="./../../../assets/decoration/moreTop.png" alt=""
          /></span>
        </div>
      </div>
      <div
        class="item"
        v-if="
          data.status != -3 &&
          data.city_agent_contract &&
          data.city_agent_contract.status == 0
        "
      >
        <div class="tipContent">
          <p v-if="data.is_agent == 1">续费基础信息待审核</p>
          <p v-else>基础信息待审核</p>
        </div>
      </div>
      <div
        class="item"
        v-if="
          data.status != -3 &&
          data.city_agent_contract &&
          data.city_agent_contract.status == 1
        "
      >
        <div class="tipContent">
          <p v-if="data.is_agent == 1">续费合同待签署</p>
          <p v-else>合同待签署</p>
          <span @click="toSignContract()">去签署</span>
        </div>
      </div>
      <div
        class="item"
        v-if="
          data.status != -3 &&
          data.city_agent_contract &&
          data.city_agent_contract.status > 2
        "
      >
        <div class="tipContent">
          <p v-if="data.is_agent == 1">续费合同待审核</p>
          <p v-else>合同待审核</p>
        </div>
      </div>
      <div
        class="item"
        v-if="
          data.status != -3 &&
          data.city_agent_contract &&
          data.city_agent_contract.status == -1 &&
          data.order_status != -10 &&
          data.order_status != -20
        "
      >
        <div class="tipContent">
          <p
            v-if="data.is_agent == 1"
            ref="detailDom"
            :class="{ unfold: isUnfold }"
          >
            续费合同被驳回：{{ data.reason }}
          </p>
          <p v-else ref="detailDom" :class="{ unfold: isUnfold }">
            合同被驳回：{{ data.reason }}
          </p>
          <span @click="afreshSign()">重新申请</span>
        </div>
        <div class="tipMore" v-if="showDetailBtn">
          <span v-if="!isUnfold" @click="isUnfold = true"
            >展开<img src="./../../../assets/decoration/moreBottom.png" alt=""
          /></span>
          <span v-if="isUnfold" @click="isUnfold = false"
            >关闭<img src="./../../../assets/decoration/moreTop.png" alt=""
          /></span>
        </div>
      </div>
      <div
        class="item"
        v-if="
          data.status != -3 &&
          data.city_agent_contract &&
          data.city_agent_contract.status == -2 &&
          data.order_status != -10 &&
          data.order_status != -20
        "
      >
        <div class="tipContent">
          <p v-if="data.is_agent == 1">续费合同被撤回</p>
          <p v-else>合同被撤回</p>
          <span @click="afreshSign()">重新申请</span>
        </div>
      </div>
      <div
        class="item"
        v-if="
          data.status != -3 &&
          data.city_agent_contract &&
          (data.city_agent_contract.status == -4 ||
            data.city_agent_contract.status == -3) &&
          data.order_status != -10 &&
          data.order_status != -20
        "
      >
        <div class="tipContent">
          <p v-if="data.is_agent == 1">续费合同已取消</p>
          <p v-else>合同已取消</p>
          <span @click="afreshSign()">重新申请</span>
        </div>
      </div>
    </div>
    <!-- 企业代理人 -->
    <div v-if="data.type == 2">
      <!-- 首次 -->
      <div v-if="data.is_agent != 1">
        <div class="item" v-if="data.status == 10">
          <div class="tipContent">
            <p>企业信息审核中</p>
          </div>
        </div>
        <div class="item" v-if="data.status == -10">
          <div class="tipContent">
            <p ref="detailDom" :class="{ unfold: isUnfold }">
              企业信息被驳回：{{ data.reason }}
            </p>
            <span @click="afreshSign()">重新申请</span>
          </div>
          <div class="tipMore" v-if="showDetailBtn">
            <span v-if="!isUnfold" @click="isUnfold = true"
              >展开<img
                src="./../../../assets/decoration/moreBottom.png"
                alt=""
            /></span>
            <span v-if="isUnfold" @click="isUnfold = false"
              >关闭<img src="./../../../assets/decoration/moreTop.png" alt=""
            /></span>
          </div>
        </div>
        <div class="item" v-if="data.status == 15">
          <div class="tipContent">
            <p>您有一笔待缴费订单，请尽快处理</p>
            <span @click="toPayFees()">去缴费</span>
          </div>
        </div>
        <div class="item" v-if="data.status == -4 && !data.city_agent_contract">
          <div class="tipContent">
            <p>代理人申请已关闭</p>
            <span @click="afreshSign()">重新申请</span>
          </div>
        </div>
        <div class="item" v-if="data.status == 20">
          <div class="tipContent">
            <p>缴费审核中</p>
          </div>
        </div>
        <div class="item" v-if="data.status == -20">
          <div class="tipContent">
            <p>缴费被驳回</p>
            <span @click="afreshSign()">重新申请</span>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            data.city_agent_contract.status == 0
          "
        >
          <div class="tipContent">
            <p>基础信息待审核</p>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            data.city_agent_contract.status == -1 &&
            data.order_status != -10 &&
            data.order_status != -20
          "
        >
          <div class="tipContent">
            <p ref="detailDom" :class="{ unfold: isUnfold }">
              合同被驳回：{{ data.reason }}
            </p>
            <span @click="afreshSign()">重新申请</span>
          </div>
          <div class="tipMore" v-if="showDetailBtn">
            <span v-if="!isUnfold" @click="isUnfold = true"
              >展开<img
                src="./../../../assets/decoration/moreBottom.png"
                alt=""
            /></span>
            <span v-if="isUnfold" @click="isUnfold = false"
              >关闭<img src="./../../../assets/decoration/moreTop.png" alt=""
            /></span>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            data.city_agent_contract.status == -2 &&
            data.order_status != -10 &&
            data.order_status != -20
          "
        >
          <div class="tipContent">
            <p>合同被撤回</p>
            <span @click="afreshSign()">重新申请</span>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            data.city_agent_contract.status == 1
          "
        >
          <div class="tipContent">
            <p>合同待签署</p>
            <span @click="toSignContract()">去签署</span>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            data.city_agent_contract.status > 2
          "
        >
          <div class="tipContent">
            <p>合同待审核</p>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            (data.city_agent_contract.status == -4 ||
              data.city_agent_contract.status == -3) &&
            data.order_status != -10 &&
            data.order_status != -20
          "
        >
          <div class="tipContent">
            <p>合同已取消</p>
            <span @click="afreshSign()">重新申请</span>
          </div>
        </div>
      </div>
      <!-- 续费 -->
      <div v-else>
        <div class="item" v-if="data.is_invalid">
          <div class="tipContent">
            <p>合同已到期</p>
            <span @click="renewalSign()">续签</span>
          </div>
        </div>
        <div class="item" v-if="data.is_expiring && data.status == 2000">
          <div class="tipContent">
            <p>合同即将到期</p>
            <span @click="renewalSign()">续签</span>
          </div>
        </div>
        <div class="item" v-if="data.status == -3">
          <div class="tipContent">
            <p ref="detailDom" :class="{ unfold: isUnfold }">
              您已被拉黑，请尽快联系工作人员处理。 拉黑原因：{{ data.reason }}
            </p>
          </div>
          <div class="tipMore" v-if="showDetailBtn">
            <span v-if="!isUnfold" @click="isUnfold = true"
              >展开<img
                src="./../../../assets/decoration/moreBottom.png"
                alt=""
            /></span>
            <span v-if="isUnfold" @click="isUnfold = false"
              >关闭<img src="./../../../assets/decoration/moreTop.png" alt=""
            /></span>
          </div>
        </div>
        <div class="item" v-if="data.status != -3 && data.renew_status == 10">
          <div class="tipContent">
            <p>续费企业信息审核中</p>
          </div>
        </div>
        <div class="item" v-if="data.status != -3 && data.renew_status == -10">
          <div class="tipContent">
            <p ref="detailDom" :class="{ unfold: isUnfold }">
              续费企业信息被驳回：{{ data.reason }}
            </p>
            <span @click="afreshSign()">重新申请</span>
          </div>
          <div class="tipMore" v-if="showDetailBtn">
            <span v-if="!isUnfold" @click="isUnfold = true"
              >展开<img
                src="./../../../assets/decoration/moreBottom.png"
                alt=""
            /></span>
            <span v-if="isUnfold" @click="isUnfold = false"
              >关闭<img src="./../../../assets/decoration/moreTop.png" alt=""
            /></span>
          </div>
        </div>
        <div class="item" v-if="data.status != -3 && data.renew_status == 15">
          <div class="tipContent">
            <p>您有一笔续费待缴费订单，请尽快处理</p>
            <span @click="toPayFees()">去缴费</span>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.renew_status == -4 &&
            !data.city_agent_contract
          "
        >
          <div class="tipContent">
            <p>续费代理人申请已关闭</p>
            <span @click="afreshSign()">重新申请</span>
          </div>
        </div>
        <div class="item" v-if="data.status != -3 && data.renew_status == 20">
          <div class="tipContent">
            <p>续费缴费审核中</p>
          </div>
        </div>
        <div class="item" v-if="data.status != -3 && data.renew_status == -20">
          <div class="tipContent">
            <p>续费缴费被驳回</p>
            <span @click="afreshSign()">重新申请</span>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            data.city_agent_contract.status == 0
          "
        >
          <div class="tipContent">
            <p>续费基础信息待审核</p>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            data.city_agent_contract.status == -1 &&
            data.order_status != -10 &&
            data.order_status != -20
          "
        >
          <div class="tipContent">
            <p ref="detailDom" :class="{ unfold: isUnfold }">
              续费合同被驳回：{{ data.reason }}
            </p>
            <span @click="afreshSign()">重新申请</span>
          </div>
          <div class="tipMore" v-if="showDetailBtn">
            <span v-if="!isUnfold" @click="isUnfold = true"
              >展开<img
                src="./../../../assets/decoration/moreBottom.png"
                alt=""
            /></span>
            <span v-if="isUnfold" @click="isUnfold = false"
              >关闭<img src="./../../../assets/decoration/moreTop.png" alt=""
            /></span>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            data.city_agent_contract.status == -2 &&
            data.order_status != -10 &&
            data.order_status != -20
          "
        >
          <div class="tipContent">
            <p>续费合同被撤回</p>
            <span @click="afreshSign()">重新申请</span>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            data.city_agent_contract.status == 1
          "
        >
          <div class="tipContent">
            <p>续费合同待签署</p>
            <span @click="toSignContract()">去签署</span>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            data.city_agent_contract.status > 2
          "
        >
          <div class="tipContent">
            <p>续费合同待审核</p>
          </div>
        </div>
        <div
          class="item"
          v-if="
            data.status != -3 &&
            data.city_agent_contract &&
            (data.city_agent_contract.status == -4 ||
              data.city_agent_contract.status == -3) &&
            data.order_status != -10 &&
            data.order_status != -20
          "
        >
          <div class="tipContent">
            <p>续费合同已取消</p>
            <span @click="afreshSign()">重新申请</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      required: true,
    },
    countDown: {
      default: 0,
    },
  },
  data() {
    return {
      showDetailBtn: false,
      detailDom: null,
      isUnfold: false,
    };
  },
  filters: {
    dataFormatting(value) {
      let val = Math.floor(value / 60) + "分" + Math.floor(value % 60) + "秒";
      return val;
    },
  },
  created() {},
  mounted() {
    this.detailDom = this.$refs.detailDom;
    this.showDetailBtnFun();
    window.addEventListener("resize", this.showDetailBtnFun);
  },
  methods: {
    showDetailBtnFun() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.detailDom = this.$refs.detailDom;
          // console.log(this.detailDom);
          if (this.detailDom) {
            this.showDetailBtn =
              this.detailDom.clientHeight < this.detailDom.scrollHeight;
          }
        }, 100);
      });
    },
    // 重新申请
    afreshSign() {
      this.$router.push({
        path: "/decoration/deputy/home",
        query: {
          type: this.data.type,
        },
      });
    },
    // 续签
    renewalSign() {
      this.$api
        .get("decoration/member/city/agent/exists", {
          category: "apply",
        })
        .then((res) => {
          console.log(res);
          if (res.is_apply_enterprise_agent && res.is_apply_individual_agent) {
            let path = "";
            if (this.data.type == 1) {
              path = "/decoration/deputy/applyFor";
            } else {
              path = "/decoration/deputy/enterpriseApplyFor";
            }
            this.$router.push({
              path: path,
              query: {
                is_white: false,
              },
            });
          } else {
            let message = "";
            if (this.data.type == 1) {
              message = "需等待企业代理人有效期结束后，才能申请该代理身份。";
            } else {
              message = "需等待个人代理人有效期结束后，才能申请该代理身份。";
            }
            this.$dialog
              .alert({
                message: message,
                confirmButtonText: "知道了",
                confirmButtonColor: "#5853E9",
              })
              .then(() => {});
          }
        });
    },
    // 去支付
    toPay() {
      this.$router.push({
        path: "/decoration/deputy/payFeesDetails",
        query: {
          order_sn: this.data.wait_pay_order.order_sn,
        },
      });
    },
    // 去签署合同
    toSignContract() {
      this.$router.push({
        path: "/decoration/deputy/signContract",
        query: {
          contract_id: this.data.city_agent_contract.contract_id,
        },
      });
    },
    // 企业代理人去缴费
    toPayFees() {
      this.$router.push({
        path: "/decoration/deputy/uploadDocuments",
      });
    },
  },
};
</script>
<style lang="less">
.detailsTop {
  .item {
    padding: 10px 16px;
    background-color: #ffdbc6;
    color: #ff7e31;
    .tipContent {
      display: flex;
      justify-content: space-between;
      // align-items: center;
      p {
        font-size: 14px;
        margin-right: 10px;
        // border: 1px solid red;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        white-space: normal;
        word-break: break-all;
        word-wrap: break-word;
        text-align: justify;
        line-height: 24px;
      }
      .unfold {
        -webkit-line-clamp: 99;
      }
      span {
        font-size: 12px;
        border-radius: 12px;
        border: 1px solid #ff7e31;
        height: 24px;
        line-height: 24px;
        min-width: 80px;
        text-align: center;
      }
    }
    .tipMore {
      display: flex;
      // justify-content: flex-end;
      span {
        font-size: 14px;
        display: flex;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
}
</style>